__turbopack_context__.v({
  "channel_button": "s8mxzG_channel_button",
  "channel_button__container": "s8mxzG_channel_button__container",
  "channel_button__logo": "s8mxzG_channel_button__logo",
  "channel_button__selected": "s8mxzG_channel_button__selected",
  "channel_button__text": "s8mxzG_channel_button__text",
  "multi_livestream__schedule__channel": "s8mxzG_multi_livestream__schedule__channel",
  "multi_livestream__schedule__channel__listings": "s8mxzG_multi_livestream__schedule__channel__listings",
});
